import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import $ from "jquery";
import { FiLogIn, FiEye, FiEyeOff } from "react-icons/fi";
import { AiFillCaretRight } from "react-icons/ai";
import Labels from "../../services/apiLabels";
import { scrollTop } from "../../utils/window";
import { POST } from "../../constant/apiMethods";
import { LOGIN, TOASTER_SHOW, toaster_w } from "../../constant";
import OverLayLoader from "../../components/OverLayLoader";
import FeedbackContext from "../../context/cmscontext";
import AuthShell from "../../components/AuthShell/AuthShell";
import { isDealerUser } from "../../utils/userTypes";
import "./dealers-login.css";

const LOGIN_VISUAL = "/images/dealers-hero-main.jpg?v=1";

function Login(props) {
  const { login, auth, toasterShow } = props;
  const { feedback } = useContext(FeedbackContext);
  const login_page = feedback.login_page || {};
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    scrollTop();
  }, []);

  const loginHandler = (event) => {
    if (event) event.preventDefault();
    if (auth.loging) return;
    const username = $("#email").val();
    const password = $("#password").val();
    if (username && password) {
      login({ username, password }, () => {});
    } else {
      toasterShow({
        show: true,
        autoHide: false,
        type: toaster_w,
        description: `please enter ${!username ? "User Name" : ""} ${
          !password ? "Password" : ""
        }`,
      });
    }
  };

  // Only treat confirmed dealer sessions as logged-in here.
  if (auth.token && isDealerUser(auth)) return <OverLayLoader alwaysShow={true} />;

  return (
    <AuthShell
      visualImage={LOGIN_VISUAL}
      visualTitle="Your wholesale desk,"
      visualTitleAccent=" always open."
      visualPoints={[
        "Live & timed auctions",
        "Buy now certified stock",
        "Network sourcing desk",
      ]}
      activeCta="signup"
    >
      <div className="dl-panel__inner">
        <p className="dl-eyebrow">Trade floor access</p>
        <h1 id="dl-heading" className="dl-title">
          {login_page.login_text || "Dealer login"}
        </h1>
        <p className="dl-lede">
          Sign in with a dealer account to bid, buy now, manage watchlists, and
          access dealer ops tools. Client accounts should use the main site.
        </p>

        <form className="dl-form" onSubmit={loginHandler} autoComplete="on">
          <div className="dl-field">
            <label htmlFor="email">{login_page.user_name || "Username"}</label>
            <input
              type="text"
              id="email"
              name="username"
              className="dl-input"
              placeholder={login_page.user_name_placeholder || "Enter username"}
              autoComplete="username"
            />
          </div>

          <div className="dl-field">
            <label htmlFor="password">
              {login_page.password_text || "Password"}
            </label>
            <div className="dl-password">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                className="dl-input dl-input--password"
                placeholder={
                  login_page.password_placeholder || "Enter password"
                }
                autoComplete="current-password"
              />
              <button
                type="button"
                className="dl-password__toggle"
                onClick={() => setShowPassword((v) => !v)}
                aria-label={showPassword ? "Hide password" : "Show password"}
                aria-pressed={showPassword}
              >
                {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
              </button>
            </div>
          </div>

          <div className="dl-row">
            <label className="dl-check" htmlFor="remember_me">
              <input type="checkbox" id="remember_me" name="remember_me" />
              <span>{login_page.remember_text || "Remember me"}</span>
            </label>
            <Link to="/dealers/forgetpassword" className="dl-link">
              {login_page.forget_text || "Forgot password"}
            </Link>
          </div>

          <button
            type="submit"
            className="dl-submit"
            name="CTAButton"
            disabled={Boolean(auth.loging)}
          >
            <FiLogIn size={16} aria-hidden />
            {auth.loging
              ? "Signing in…"
              : login_page.submit_text || "Sign in"}
          </button>
        </form>

        <p className="dl-footer-note">
          {login_page.dont_text || "Don't have an account?"}{" "}
          <Link to="/signup?role=dealer">
            {login_page.signup_text || "Request access"}
            <AiFillCaretRight size={14} aria-hidden />
          </Link>
        </p>
      </div>
    </AuthShell>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  login: (data, callBack) =>
    dispatch({
      type: LOGIN,
      payload: {
        type: LOGIN,
        method: POST,
        label: Labels.login,
        data,
        callBack,
      },
    }),
  toasterShow: (data) =>
    dispatch({
      type: TOASTER_SHOW,
      payload: {
        ...data,
      },
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
